import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
  ElementRef,
  ViewChild,
  NgZone
} from '@angular/core';
import { SETTINGS } from 'src/app/core/config/common.settings';
import * as mapboxgl from 'mapbox-gl';

@Component({
  selector: 'app-interactive-map',
  templateUrl: './interactive-map.component.html',
  styleUrls: ['./interactive-map.component.scss']
})
export class InteractiveMapComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() viewType: any;
  @Output() coordinatesChanged = new EventEmitter<{ lng: number; lat: number }>();
  @ViewChild("mapContainer", {static: false}) mapContainer?: ElementRef<HTMLElement>;
  private _destinationCord?: any;
  map!: mapboxgl.Map;
  marker!: mapboxgl.Marker;
  lngLat: [number, number] = [-0.1276, 51.5074];
  readonly mapboxAccessToken = SETTINGS.MAP_BOX_ACCESS.TOKEN;

  constructor(private zone: NgZone) {
    (mapboxgl as any).accessToken = this.mapboxAccessToken;
  }

  @Input()
  set destinationCord(value: any | undefined) {
    this._destinationCord = value;
    if (value) {
      const newLngLat: [number, number] = [value.longitude, value.latitude];
      const changed = !this.lngLat || this.lngLat[0] !== newLngLat[0] || this.lngLat[1] !== newLngLat[1];
      this.lngLat = newLngLat;
      if (this.map && this.marker) {
        if (changed) {
          this.marker.setLngLat(this.lngLat);
          this.map.setCenter(this.lngLat);
        }
      }
    }
  }

  get destinationCord(): any | undefined {
    return this._destinationCord;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.initializeMap();
  }

  initializeMap(): void {
    const containerEl = this.mapContainer?.nativeElement;

    this.map = new mapboxgl.Map({
      container: containerEl as HTMLElement,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: this.lngLat,
      zoom: 15,
      dragPan: true,
      scrollZoom: true,
      boxZoom: false,
      doubleClickZoom: false,
      dragRotate: false,
      keyboard: false,
    });

    this.map.addControl(new mapboxgl.NavigationControl());

    this.marker = new mapboxgl.Marker({ draggable: true, color: "#000000" })
      .setLngLat(this.lngLat)
      .addTo(this.map);

    // Keep marker at map center while panning
    this.map.on('move', () => {
      const center = this.map.getCenter();
      this.marker.setLngLat(center);
    });

    // Emit final center after pan ends
    this.map.on('moveend', () => {
      const center = this.map.getCenter();
      this.zone.run(() => {
        this.lngLat = [center.lng, center.lat];
        this.coordinatesChanged.emit({ lng: center.lng, lat: center.lat });
      });
    });

    // Final emit after drag finishes
    this.marker.on('dragend', () => {
      const ll = this.marker.getLngLat();
      this.zone.run(() => {
        this.lngLat = [ll.lng, ll.lat];
        this.coordinatesChanged.emit({ lng: ll.lng, lat: ll.lat });
      });
    });
  }


  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
    }
  }

  protected readonly Math = Math;
}
